export default {
    account_locked: 'account_locked',
    autoLoginError: 'autoLoginError',
    emailNotFound: 'emailNotFound',
    expectedSrcPartOnLoad: 'expectedSrcPartOnLoad',
    fieldEmpty: 'fieldEmpty',
    fieldIncorrect: 'fieldIncorrect',
    iframeLoadError: 'iframeLoadError',
    invalidAttempt: 'invalidAttempt',
    invalidToken: 'invalidToken',
    invalidTokenOrEmail: 'invalidTokenOrEmail',
    loadTimeout: 'loadTimeout',
    loginError: 'checkIfLoggedInError',
    login_failure: 'login_failure',
    notLoggedIn: 'notLoggedIn',
    userAlreadyExists: 'userAlreadyExists'
};
